/**
 * Alternative to https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
 * which can also be applied on a text node.
 */
export function findDOMClosest(el: Element | Text | Node, selector: string): Element | null {
    if (el instanceof Element) {
        return el.closest(selector);
    }

    if (!el.parentElement) {
        return null;
    }

    return findDOMClosest(el.parentElement, selector);
}
